// @ts-nocheck

import React, { useEffect } from 'react'
import ThankYouPopUp from '../ThankYouPopUp/ThankYouPopUp'
import TagManager from 'react-gtm-module'
import { useLocation } from 'react-router-dom';



const ThankyouPage = () => {

  const location = useLocation();

  // Initialize GTM only once (better to do this in App.js)
  useEffect(() => {
    
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js'
      });
      
      const script = document.createElement('script');
      script.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-WJNKG7HZ';
      script.async = true;
      document.head.appendChild(script);
    
  }, []);

  // Track component-specific page view
  useEffect(() => {
    window.dataLayer.push({
      event: 'pageView',
      page: location.pathname,
      pageTitle: 'Thankyou Page', // Custom title for this component
      component: 'Thankyou'    // Additional component identifier
    });
  }, [location]);
  
  

  return (
    <ThankYouPopUp/>
  )
}

export default ThankyouPage